import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Spinner from '../ui/Spinner';
import { useAuth } from '../../context/AuthContext';

// Requires an authenticated user. Waits for the initial auth check to settle
// (so a valid session isn't bounced on refresh), then fails closed to home.
export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="ss-container" style={{ paddingBlock: 'var(--ss-space-8)', textAlign: 'center' }}>
        <Spinner label="Checking your session" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
